import { BcStateForm, BcStateListContext, Spinner } from '@bayclubs/state';
import { EnumerationModel, CourtForAddBlockedSlotModel } from '@bayclubs/court-booking-employee-api';

import { BlockedSlotSaveFormModel } from './../models/blocked-slot-save-form.model';

export const BLOCKED_SLOT_SAVE_FEATURE_KEY = 'blockedSlotSave';

export interface BlockedSlotSaveStateModel {
  form: BcStateForm<BlockedSlotSaveFormModel>;
  clubCourts: BcStateListContext<CourtForAddBlockedSlotModel>;
  blockedSlotTypes: BcStateListContext<EnumerationModel>;
  spinner: Spinner;
}
